
document.addEventListener('DOMContentLoaded' , () =>{
	//header gnb
	const body = document.body,
		  gnbOpenBtn = document.querySelectorAll('.js-gnb-open'),
		  gnbCloseBtn = document.querySelector('.js-gnb-close'),
		  gnbToggleBtn = document.querySelectorAll('.js_gnb_toggleBtn'),
		  gnbDepth2 = document.querySelectorAll('.depth2');

	if(document.querySelector('.gnb')){
		gnbOpenBtn.forEach(function(el){
			el.addEventListener('click' , function(){
				body.classList.add('ovf');
				$(".js-gnb").show(100, function(){
					$(".js-gnb .gnb__content").stop().animate({"left":"0"}, 450);
					$('.gnb-slide-area .gnb-slide-area__list').slick('refresh');
				});

				gnbToggleBtn.forEach(function(el){
					let gnbToggleBtnArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js_gnb_toggleBtn'));

					el.addEventListener('click' , function(e){
						if(el.classList.contains('active')){
							el.classList.remove('active');
						}else{
							gnbToggleBtnArray.forEach(function(el){
								el.classList.remove('active');
							});
							el.classList.add('active');
						}
					});
				})

				//gnb depth2 전체보기 하나일 때 col1 class 추가
				gnbDepth2.forEach(function(el){
					let targetLi = el.querySelectorAll('li').length;

					if(targetLi == 1){
						el.classList.add('col1');
					}
				})

				gnbCloseBtn.addEventListener('click' , function(){
					body.classList.remove('ovf');
					$(".js-gnb .gnb__content").stop().animate({"left":"-100%"}, 450);
					setTimeout(function(){
						$(".js-gnb").hide();
					}, 450);
				});
			});
		})

		$('.gnb-slide-area .gnb-slide-area__list').slick({
			// lazyLoad: 'ondemand',
            dots:true,
            arrows:false,
            autoplay:true,
        });
	}

	//header height
	let headerH = document.getElementById('header').offsetHeight,
		contentH = document.querySelector('.content');

	if(document.querySelector('.lnb')){
		function resizeContents(){
			let lnbH = document.querySelector('.lnb').offsetHeight;
			if(contentH.classList.contains("mypage") && !contentH.classList.contains("withdrawal-page")){
				let sideAreaH = document.querySelector('.side-area');
				sideAreaH.style.marginTop = headerH + lnbH + 'px';
			}else{
				contentH.style.marginTop = headerH + lnbH + 'px';
			}
		}
		resizeContents();

		window.addEventListener('resize', function(){
			if (window.innerWidth <= 768) {
				resizeContents();
				// console.log('mb');
			}else{
				resizeContents();
				// console.log('pc');
			}
		});
	}else{
		contentH.style.marginTop = headerH + 'px';
	}

	if (document.querySelector('.header')) {	
		const header = document.querySelector('.header');
		let headerH = document.getElementById('header').offsetHeight;
	
		window.addEventListener('scroll', () => {
			if (window.scrollY >= headerH) {
				header.classList.add('scroll-fixed');
			} else {
				header.classList.remove('scroll-fixed');
			}
		});
	}

	// 비밀번호 보기
	const hiddenShow = document.querySelectorAll('.js_hiddenShow');

	class hiddenShowBox {
		constructor(target) {
			this.target = target;
			this.hiddenShowBtn = this.target.querySelector('.hidden-show__btn');
			this.hiddenShowIp = this.target.querySelector(".hidden-show__input");
		}

		hiddenShowFn() {
			const _this = this;
			
			this.hiddenShowBtn.addEventListener("click" , function(){
				if(_this.hiddenShowIp.type === 'password'){
					_this.hiddenShowIp.type = 'text';
					_this.hiddenShowBtn.classList.add('on');
				}else{
					_this.hiddenShowIp.type = 'password';
					_this.hiddenShowBtn.classList.remove('on');
				}
			})
		}
	}    
	hiddenShow.forEach(el => {        
		new hiddenShowBox(el).hiddenShowFn();
	});

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}

	//tooltip
	if(document.querySelector('.js-tooltip')){
		const tooltipBtn = document.querySelectorAll('.js-tooltip');
	
		tooltipBtn.forEach(el => {
			el.addEventListener('click' , function(){
				el.classList.toggle('on');
			});
		});  
	}
	
	//image-btn-content__slide
	if(document.querySelector('.image-btn-content__slide')){
		let swiper = new Swiper(".image-btn-content__slide .swiper", {
			loop: false,
			loopAdditionalSlides: 1,
			slidesPerView: 'auto',
			slidesPerGroup: 9,
			navigation: {
				nextEl: ".swiper-button--next",
				prevEl: ".swiper-button--prev",
			},
			breakpoints:{
				768 : {
					//768px 이하의 크기에서 옵션 값 
					slidesPerGroup: 1,
				}
			}
		});
	}

	//search
	if(document.querySelector('.js-search')){
		const searchDefault = document.querySelectorAll('.js-search');
	
		searchDefault.forEach(el => {
			let _searchInput = el.querySelector('input'),
				_searchDelete = el.querySelector('.search__delete');

			_searchInput.addEventListener('input' , function(e){
				if(e.target.value == ''){
					_searchDelete.style.display = 'none';
				}else{
					_searchDelete.style.display = 'block';
				}
			});
		});  
	}

	//layer--search-layer 검색 레이어 최근 본 제품 슬라이드
	if(document.querySelector('.js-search-layer')){
		$('.search-list--product .prd-list').slick({
			variableWidth: true,
			arrows: true
		});
	}

	// footer - floating button
	if(document.querySelector('.js-floating-button')){
		const floatingButton = document.querySelector('.js-floating-button');

		window.addEventListener('scroll' , ()=>{
			if(window.scrollY >= floatingButton.clientHeight){
				floatingButton.classList.add('scroll');
			} else {
				floatingButton.classList.remove('scroll');
			}
		})
	}

	// footer - toggle menu
	if(document.querySelector('.js-toggle-menu')){
		const toggleButton = document.querySelectorAll('.js-toggle-menu li>button');

		toggleButton.forEach(function(el){
			el.addEventListener('click' , function(){
				el.classList.toggle('active');
			});
		})
	}

	if(document.querySelector('.search .common-icon--delete')){
		const searchDelBtn = document.querySelectorAll('.search .common-icon--delete');

		searchDelBtn.forEach(function(el){
			el.addEventListener('click' , function(e){
				e.currentTarget.closest(".search").querySelector("input").value = '';
			});
		})
	}
});
